import { render, staticRenderFns } from "./FootnoteUpload.vue?vue&type=template&id=42612571"
import script from "./FootnoteUpload.vue?vue&type=script&lang=js"
export * from "./FootnoteUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports